import Link from "next/link";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

const LearnBreadcrumbs = ({
  currentPage = 1,
  categoryTitle = null,
  categorySlug = null,
  postTitle = null,
}) => {
  return (
    <div>
      <div className="wrapper py-4">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link href="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />

            <BreadcrumbItem>
              {!categoryTitle && !postTitle && currentPage === 1 ? (
                <BreadcrumbPage>Resources</BreadcrumbPage>
              ) : (
                <BreadcrumbLink asChild>
                  <Link href="/resources">Resources</Link>
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>

            {/* Category breadcrumb */}
            {categoryTitle && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {!postTitle && currentPage === 1 ? (
                    <BreadcrumbPage>{categoryTitle}</BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link href={`/resources/category/${categorySlug}`}>
                        {categoryTitle}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
              </>
            )}

            {/* Page number for pagination */}
            {currentPage > 1 && !postTitle && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Page {currentPage}</BreadcrumbPage>
                </BreadcrumbItem>
              </>
            )}

            {/* Post title */}
            {postTitle && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="line-clamp-1">
                    {postTitle}
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </>
            )}
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  );
};

export default LearnBreadcrumbs;
